<template>
  <div>
    <NewGroup @created="$emit('created')" />
    <ViewGroup :group_id="group_id" @updated="$emit('updated')" />
    <div class="row">
      <div class="col-auto">
        <v-btn
          v-if="permissions.permission_admin.write"
          class="v-primary mb-1"
          @click="$bvModal.show('new_group')"
        >
          <span class="fa fa-plus"></span> Nova
        </v-btn>
      </div>
      <div class="col"><h6>Grupos</h6></div>
      <div class="col">
        <v-text-field
          v-model="group_search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        />
      </div>
    </div>
    <div class="row">
      <ErrorsMessages :errors="errors" />
      <div class="col">
        <v-data-table
          dense
          :headers="group_headers"
          :items="group_items"
          :search="group_search"
          :footer-props="{
            'items-per-page-options': [25, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          @click:row="openGroupViewModal"
        >
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import NewGroup from "./NewGroup";
import ViewGroup from "./ViewGroup";

import ErrorsMessages from "../components/ErrorsMessages";

import api from "../../services/api";
import { adminData } from "../../lib/functions";
export default {
  name: "GroupsList",
  components: {
    NewGroup,
    ViewGroup,
    ErrorsMessages,
  },
  props: {
    needs_refresh: Boolean,
  },
  watch: {
    needs_refresh: function (newValue) {
      if (newValue) {
        this.getGroups();
        this.$emit("refreshed");
      }
    },
  },
  data() {
    return {
      permissions: {},
      errors: [],

      group_search: "",
      group_headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Nome", value: "name" },
      ],
      group_items: [],
      group_id: "",
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.getGroups();
  },
  methods: {
    async getGroups() {
      try {
        this.loading = true;

        let response = await api.get("/admin/permission/groups");
        let { error, errors, groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.group_items = groups;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async openGroupViewModal(item) {
      this.group_id = item.id;
      this.$bvModal.show("view_group");
    },
  },
};
</script>

<style>
</style>